import styled from '@emotion/styled'

export const EventPageWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding-bottom: 30vmin;
  background: #fff;
  .event-page-img {
    width: 100%;
    height: auto;
  }
  .event-page-gif {
    position: absolute;
    top: 64.8vmin;
    left: 50%;
    transform: translateX(-50%);
    width: 43.1vw;
    &.pc {
      top: 850px;
      width: 550px;
    }
  }
  .event-page-btn {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 1280px;
    height: auto;
    border-radius: 0;
    background: none;
    img {
      width: inherit;
      height: auto;
    }
    &.pc {
      width: 550px;
    }
  }
  @media (max-width: 1000px) and (orientation: landscape) {
    .event-page-gif:not(.pc) {
      top: 120vmin;
    }
   }

`
